
import { logger } from "@/utils/logger";
import { defineAsyncComponent, ref } from "vue";
import { Options, Vue } from "vue-class-component";
import { AssociatedParty, OfferAssociatedParty, PicklistItem, TaskDefinition, Third } from "@/types";
import store from "@/store";

import DemandTabThird from "@/components/demand/tabs/DemandTabThird.vue";
import DemandRegister from "@/components/demand/details/DemandRegister.vue";
import i18n from "@/i18n";
import Notify from 'quasar/src/plugins/Notify.js';;
import { useRoute } from "vue-router";
import { enrichClassifications, ValidateMandatoryFields } from "@/utils";

const DemandAssetTab = defineAsyncComponent(() => import("@/components/demand/tabs/DemandAssetTab.vue"));
const DemandTabFinancing = defineAsyncComponent(() => import("@/components/demand/tabs/DemandTabFinancing.vue"));
const Avis = defineAsyncComponent(() => import("@/components/demand/tabs/Avis.vue"));
const DocumentManagment = defineAsyncComponent(() => import("@/components/task/tabs/documentManagment/DocumentManagment.vue"));
const Study = defineAsyncComponent(() => import("@/components/Analysis/Study.vue"));
const Decisions = defineAsyncComponent(() => import("@/components/task/tabs/Opinion/Decision.vue"));
const Financing = defineAsyncComponent(() => import("@/components/middle-office/tabs/Financing.vue"));

@Options({
  components: {
    Financing,
    DemandTabFinancing,
    DemandTabThird,
    DemandAssetTab,
    DemandRegister,
    Avis,
    Study,
    Decisions,
    DocumentManagment
  },
  computed: {
    isBtnCalendarDisabled() {
      return store.state.simulationModule.pricingCalculationResponse === undefined;
    },
    isNormalMode() {
      return store.state.simulationModule.typeSimulation === "normal";
    },
    isExpertMode() {
      return store.state.simulationModule.typeSimulation === "expert";
    },
  },
  watch: {
    "$store.state.financingModule.simulationChanged"(simulationChanged) {
      this.simulationChanged = simulationChanged;
    },
    "$store.state.financingModule.serviceModule.calculationPendent"(calculationPendent) {
      this.calculationPendent = calculationPendent;
    },
  },
})
export default class DemandEdit extends Vue {
  openDialog = "";
  showDialog?: boolean = false;
  summaryPanel?: boolean = false;
  simulationChanged?: boolean = false;
  calculationPendent?: boolean = false;
  tab = ref("tiers");
  internTab: any = ref(1);
  channel = ref("Démarche");
  date = ref(new Date());
  roles: PicklistItem[] = [];
  taskDefinition: any;
  ValidateMandatoryFields = ValidateMandatoryFields;
  get offerMO() {
    return store.state.middleOfficeModule.offer ? store.state.middleOfficeModule.offer : store.state.taskModule.offer;
  }
  get proposals() {
    return this.offerMO!.proposals;
  }

  get currentRoute() {
    logger.debug('test',useRoute().name)
    return useRoute().name;
  }
  get getRole() {
    const roleItems = store.getters["picklistModule/roleItems"];
    const roleIdMapping = roleItems.map((item: any) => ({
      id: item.value,
      label: item.label,
    }));
    return roleIdMapping;
  }
  get offer() {
    return store.state.demandModule?.offer;
  }

  get associatedParties() {
    if (!this.offer || !this.offer.associatedParties) {
      return [];
    }
    const associatedParties = this.offer.associatedParties.sort(
      (a: any, b: any) => a.id - b.id
    );
    associatedParties?.forEach((associatedParty) => {
      const classifications = associatedParty.associatedParty?.third?.classifications;
      const pendingNodes = classifications?.filter((node: any) => !node.classType);
      if (pendingNodes?.length) {
        enrichClassifications(pendingNodes).then(() => {
          pendingNodes.forEach((node: any) => {
            node.isDisabled = true;
          });
        });
      }
    });

    
    return associatedParties.filter((party:any)=>party.associatedParty.role.resourceUid.toLowerCase() !== 'sg').map((el: any) => {
      if(!el.signatureMethod){
        if (el.role_code !== "DISTRIBUTOR") {
          el.signatureMethod = "ELECTRONIC";
        }
        else {
          el.signatureMethod = "MANUAL";
        }
      }
      return el;
    });
  }
  get disabled(){
    return !store.getters["taskModule/isTaskIsAssignedToConnectedUser"];
  }
  get party() {
    return this.associatedParties?.[0].associatedParty?.third;
  }

  get assetState() {
    return store.state.demandModule.assetState;
  }

  get assets() {
    return this.assetState.proposalAssets;
  }
  get isLoading() {
    return store.state.analysisModule?.isLoading;
  }


  get screenStatus() {
    let MOScreen = false;
      if (store.state.taskModule.selectedTask.taskDefinition === TaskDefinition.ANALYSIS) {
        MOScreen = true
      }

    return MOScreen;
  }

  addInternThirdTab(role: any) {
    const associatedParty: OfferAssociatedParty =
      store.getters["demandModule/getOfferAssociatedPartyInit"];
    associatedParty.id = this.associatedParties?.length
      ? this.associatedParties?.length + 1
      : associatedParty.id++;
    associatedParty.tabName = role.id;
    associatedParty.showDeleteBtn = true;
    associatedParty.role_code = role.id;
    const third: any = associatedParty?.associatedParty?.third;
    third.person.roles[0].role.resourceUid = role.id;
    third.organization.roles[0].role.resourceUid = role.id;
    store.dispatch("demandModule/addAssociatedParty", associatedParty);
    logger.debug('associatedParty',associatedParty)
  }

  removeAssociatedParty(index: number, associatedParty: AssociatedParty) {
    if (
      this.associatedParties?.[index] !== undefined &&
      this.associatedParties?.length > 1 &&
      this.associatedParties?.[index].id !== 1
    ) {
      this.associatedParties?.splice(index, 1);
      this.associatedParties?.forEach((value, i) => {
        value.id = i + 1;
        value.showDeleteBtn = value.id !== 1;
      });
      const customer = this.associatedParties.find(
        (el: any) => el.associatedParty?.role.resourceUid === "CUSTOMER"
      );
      if (customer) {
        const relations = customer.associatedParty?.third?.organization?.relations;
        if (relations) {
          relations.splice(
            relations.findIndex(
              (relation: any) =>
                associatedParty.third?.person &&
                relation.partyAsc.resourceUid ===
                  associatedParty.third?.person?.resourceUid
            ),
            1
          );
        }
        store.state.demandModule.deletedManager = associatedParty;
      }
    }
  }

  onClose() {
    this.showDialog = false;
  }

  get isSaveLoading() {
    return store.state.demandModule.isSaving;
  }

  onSaveClick() {
    if (!this.simulationChanged && !this.calculationPendent) {
      if (!this.isSaveLoading) {
        store.dispatch("controlsModule/evaluateOfferControls", {
          onSuccess: () =>
            store.dispatch("demandModule/saveOffer", store.state.demandModule.offer),
          onFail: (message: string) => {
            Notify.create({
            timeout: 10000,
            actions: [{ icon: 'close', color: 'white' }],
              message,
              color: "warning",
            });
          },
        });
      }
    } else {
      Notify.create({
        timeout: 10000,
        actions: [{ icon: 'close', color: 'white' }],
        message: "Prière de verifier le calcul de votre quotation.",
        color: "warning",
      });
    }
  }

  thirdName(third: Third) {
    if (third) {
      if (third.organization) {
        return third.organization.name;
      } else if (third.person) {
        return `${third.person.firstName} ${third.person.familyName}`;
      } else return "";
    }
  }
  get decisionsStep() {
    if (store.state.taskModule.modifyConditionsModule.decisionStep) {
      return store.state.taskModule.modifyConditionsModule.decisionStep;
    }
    return [
      {
        config: {},
        decisions: [],
      },
    ];
  }
   get listDecision() {
    return store.state.taskModule.offer && store.state.taskModule.offer!.proposals[0] && store.state.taskModule.offer!.proposals[0].proposalDecisions 
           ? store.state.taskModule.offer!.proposals[0].proposalDecisions : [];
  }
  isTaskAnalysis() {
    return store.getters["taskModule/isTaskAnalysis"];
  }
  updateResultRows(rows: any) {
    const row = rows[0];
    store.dispatch("demandModule/setOfferQueryData", row);
  }

  created() {
    if(store.state.taskModule.updateDelegationLvlProcess?.length !== 0){
      store.state.taskModule.updateDelegationLvlProcess = '';
    }
    this.taskDefinition = this.$store.state.taskModule.selectedTask.taskDefinition;
    const offerId = this.$store.state.taskModule.offer?.resourceUid;
    const id = this.$route.params.id;
    if (id) {
      const resourceUid = id;
      const filters = {
        id : id
      }
      store.dispatch("demandModule/searchOffer", {
        callback: this.updateResultRows,
        filter: filters,
        offset: 0,
        limit: 1
      }).then(() => {
        store.dispatch("demandModule/editOffer", {
          resourceUid: resourceUid,
          callback: () => { },
        });
      });
    }
    if (!this.isTaskAnalysis) {
      store.dispatch("lockState");
}
    store.dispatch("demandModule/fetchRules").then((roles) => {
      roles.sort((a: any, b: any) => {
        const labelA = i18n.global.t("demand.party.roles.".concat(a.code));
        const labelB = i18n.global.t("demand.party.roles.".concat(b.code));
        return labelA.localeCompare(labelB);
      });
      // Clear the roles array before pushing the sorted roles
      this.roles = [];
      roles.forEach((role: any) =>
        this.roles.push({
          id: role.code,
          label: i18n.global.t("demand.party.roles.".concat(role.code)),
        })
      );
    });
    
    store.dispatch("taskModule/listDecision", {
      listDecision: this.listDecision,
      callback: () => {},
    });
  }
  updated() {
    this.$emit('update');
  }
  
}
